"use client";

import { useEffect } from "react";
import { ChatInterface } from "@/components/chat";

export function ChatInterfaceWrapper() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      // eslint-disable-next-line no-console
      console.error("[window.error]", event.message, event.filename, event.lineno, event.colno);
    };

    const onRejection = (event: PromiseRejectionEvent) => {
      // eslint-disable-next-line no-console
      console.error("[unhandledrejection]", event.reason);
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return <ChatInterface />;
}

